import * as types from "./constant";
// import apis from "@/apis";
export default {
  state: {
    userInfo: {},
    waitPayOrderId: null
  },
  actions: {
    async setUserInfo({ commit }, userInfo) {
      if (!userInfo) {
        userInfo = {
          headImg: null,
          phone: null,
          userName: null,
          nickname: null,
          sessionId: null,
          openId: null
        };
      }
      commit(types.USER_INFO, userInfo);
    }
  },
  mutations: {
    [types.USER_INFO](state, payload) {
      state.userInfo = payload;
    },
    setWaitPayOrderId(state, payload) {
      console.log("????orderId");
      state.waitPayOrderId = payload;
    }
  },
  getters: {
    sessionId(state) {
      return state.userInfo.sessionId;
    },
    userInfo(state) {
      return state.userInfo;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js